import { createRouteContextObject } from '@shared/utils';
import { HttpContextBase } from './http-context-base.enum';

enum HttpContextRoutes {
  GetUser,
  GetZendeskMessagingToken,
}

export const HttpSharedCoreContext = createRouteContextObject(
  HttpContextBase.SharedCore,
  HttpContextRoutes
);
